import styled from "styled-components";

export const DashedSeparatorStyle = styled.div`
  border-bottom: dashed white 0.4em;
  color: white;
  align-self: center;
  width: 20%;
`;
